import { render } from "./UpdateProductDialog.vue?vue&type=template&id=0e9e13da&scoped=true"
import script from "./UpdateProductDialog.vue?vue&type=script&lang=js"
export * from "./UpdateProductDialog.vue?vue&type=script&lang=js"

import "./UpdateProductDialog.vue?vue&type=style&index=0&id=0e9e13da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9e13da"]])

export default __exports__